import { TouchableOpacity, Platform } from 'react-native'

let TouchableBouncer = TouchableOpacity

if (Platform.OS !== 'web') {
  TouchableBouncer = require('react-native/Libraries/Components/Touchable/TouchableBounce')
}

export default TouchableBouncer
